import { render, staticRenderFns } from "./xidada.vue?vue&type=template&id=fc3da5f4&scoped=true&"
import script from "./xidada.vue?vue&type=script&lang=js&"
export * from "./xidada.vue?vue&type=script&lang=js&"
import style0 from "./xidada.vue?vue&type=style&index=0&id=fc3da5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3da5f4",
  null
  
)

export default component.exports